export const config = {
    sanctumUrl: `//${process.env.VITE_DOMAIN}/sanctum/csrf-cookie`,
};
